import React from "react";
import './taFormField.css';

export const TaFormFieldError = ({children}) => {
  return children ? <div className="ta-form-field__error">{children}</div> : null;
};